import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=0fb02488&scoped=true&"
import script from "./MessageListItem.vue?vue&type=script&lang=js&"
export * from "./MessageListItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageListItem.vue?vue&type=style&index=0&id=0fb02488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb02488",
  null
  
)

export default component.exports